import { MapControls, MapConstant } from '../../../../../../../../lib/Map';

const RouteMapControls = () => {
  return (
    <MapControls
      controlOptions={{
        zoomControl: {
          position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT
        },
        satelliteViewControl: {
          position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT
        },
        reCenterMapControl: {
          position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT
        }
      }}
    />
  );
};

export default RouteMapControls;
